var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-hidden"},[_c('div',{staticClass:"d-flex flex-column min-vh-100"},[_c('ul',[_c('li',[_c('div',{staticClass:"text-center",attrs:{"id":"itemlist"}},[_c('Mymailscore'),_c('div',{staticStyle:{"padding":"4.8rem 0 0 0"}})],1)])])]),_c('Mybottommenu',{ref:"con3",attrs:{"show":false},on:{"savelove":_vm.savelove}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }